module.exports = __webpack_public_path__ + "img/img_six_cont2.313b3888.png";